import { domain } from 'modules/data';

export const placeholderList = [
    domain.SupplierEmailReplacements.quoteNumber,
    domain.SupplierEmailReplacements.totalAmount,
    domain.SupplierEmailReplacements.customerName,
    domain.SupplierEmailReplacements.companyName,
    domain.SupplierEmailReplacements.contactPersonName,
    domain.SupplierEmailReplacements.decisionMakingWebPageLink,
    domain.SupplierEmailReplacements.terms,
];
